import CodedError, { ERROR_CODE } from "../../util/CodedError";

class ErrorController {
  constructor() {
    this.name = 'error';
  }

  $onInit() {
    this.error = this.error || new CodedError(undefined, ERROR_CODE.UNKNOWN);
  }
}

export default ErrorController;



// WEBPACK FOOTER //
// ./client/app/components/error/error.controller.js